import { Card, CardHeader, CardFooter } from '@/components/ui/card';
import { useTranslation } from 'react-i18next';

interface MenuItemsSkeletonProps {
  count?: number;
}

export function MenuItemsSkeleton({ count = 3 }: MenuItemsSkeletonProps) {
  const { t } = useTranslation();

  return (
    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
      {Array(count)
        .fill(0)
        .map((_, i) => (
          <Card key={i} className='animate-pulse'>
            <div className='h-48 bg-muted rounded-t-lg'></div>
            <CardHeader>
              <div className='h-6 bg-muted rounded w-3/4 mb-2'></div>
              <div className='h-4 bg-muted rounded w-1/2'></div>
            </CardHeader>
            <CardFooter className='flex justify-between'>
              <div className='h-8 bg-muted rounded w-1/3'></div>
              <div className='h-8 bg-muted rounded w-1/4'></div>
            </CardFooter>
          </Card>
        ))}
    </div>
  );
}
